module.exports = __webpack_public_path__ + "static/media/mongodb.e08ed2d5.svg";